module.exports = __webpack_public_path__ + "static/fee03-141332fe8046d1892232430459d74072.png";